import IconButton from '@mui/material/IconButton';
import styled from 'styled-components';

import colors from 'app/styles/theme/colors';
import { StyledDialog as BaseStyledDialog } from 'app/components/StyledDialog/styles';
import { dialogPaper } from 'app/components/DialogFrame/styles';

export {
  Head,
  Title,
  Description,
  Body,
  Foot,
  ResultState,
  ResultIcon,
  ResultTitle,
  ResultMessage,
} from 'app/components/DialogFrame/styles';
export { SecondaryButton, PrimaryButton } from 'app/components/DialogFooterButtons/styles';

const { gray } = colors.designSystem;

export const StyledDialog = styled(BaseStyledDialog)`
  .MuiDialog-paper {
    width: 1040px;
    ${dialogPaper}
  }
`;

export const CloseButton = styled(IconButton)`
  color: ${gray[700]} !important;
  padding: 4px !important;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
`;
